<app-sprite-svg></app-sprite-svg>
<mat-progress-bar
  mode="indeterminate"
  class="loading"
  *ngIf="loading"
>
</mat-progress-bar>

<router-outlet></router-outlet>

<app-loading></app-loading>
